import Component from '@glimmer/component';

import LinksTo from 'ember-route-state/components/links-to.gjs';

import CIcon from 'rise-ui/components/c-icon.gjs';
import string from 'rise-ui/helpers/string.js';

export default class ModalCloseButtonComponent extends Component {
  <template>
    <LinksTo class="c-modal-close-button" @onClick={{@onClick}}>
      <CIcon @icon="exit" @text={{string "close-modal"}} />
    </LinksTo>
  </template>
}
